import { Box, Button, DialogActions } from "@mui/material";
import React from "react";
import { FireFoxA2HSIcon, IOSShareIcon, MenuIcon, OperaA2HSIcon } from "./InstallPwaIcons";
import { InstallPwaDialogResultReason } from "./InstallPwaDialog";
import InstallPwaDialogActionInstructions from "./InstallPwaDialogActionInstructions";
import { getPlatform, platforms } from "./InstallPwaPlatforms";

type InstallPwaDialogActionProps = {
    onClose: (reason: InstallPwaDialogResultReason) => void;
};

export default function InstallPwaDialogAction({
    onClose
}: InstallPwaDialogActionProps) {
    const platform = getPlatform();

    return (
        <>
            <DialogActions>
                {platform === platforms.NATIVE && (
                    <>
                        <Button onClick={() => onClose("postpone")}>Remind Me Later</Button>
                        <Button onClick={() => onClose("disable")}>Don't Remind Me Again</Button>
                        <Button onClick={() => onClose("install")} color="secondary" variant="text" disableElevation>
                            Install Now
                        </Button>
                    </>
                )}

                {platform === platforms.IDEVICE && (
                    <InstallPwaDialogActionInstructions
                        action1={
                            <>
                                Tap the share button:
                                <IOSShareIcon />
                            </>
                        }
                        action2="then find and tap 'Add to Homescreen'"
                        onClose={onClose}
                    />
                )}

                {platform === platforms.FIREFOX && (
                    <InstallPwaDialogActionInstructions
                        action1={
                            <>
                                Tap this icon on the address bar:
                                <FireFoxA2HSIcon />
                            </>
                        }
                        action2="then tap '+Add to Homescreen'"
                        onClose={onClose}
                    />
                )}

                {platform === platforms.FIREFOX_NEW && (
                    <InstallPwaDialogActionInstructions
                        action1={
                            <>
                                Tap the menu button:
                                <MenuIcon />
                            </>
                        }
                        action2="then tap 'Install'"
                        onClose={onClose}
                    />
                )}

                {platform === platforms.OPERA && (
                    <InstallPwaDialogActionInstructions
                        action1={
                            <>
                                Tap the menu button:
                                <MenuIcon />
                            </>
                        }
                        action2={
                            <>
                                then tap &nbsp;'
                                <OperaA2HSIcon />
                                Home screen'
                            </>
                        }
                        onClose={onClose}
                    />
                )}

                {platform === platforms.OTHER && (
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column"
                        }}>
                        
                        <Box>Unfortunately the install feature is not supported by your browser.</Box>
                        
                        <Box
                            sx={{
                                width: "100%",
                                textAlign: "right"
                            }}>
                            <Button onClick={() => onClose("disable")}>Ok</Button>
                        </Box>
                    </Box>
                )}
            </DialogActions>
        </>
    );
}
